import {
  Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/workorders';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async getWorkOrders(params: any) {
    return api.getWorkOrders(params);
  }

  @Action
  async getComments(params: any) {
    return api.getComments(params);
  }

  @Action
  async reply(params: any) {
    return api.reply(params);
  }

  @Action
  async getVipExcel(params: any) {
    return api.getVipExcel(params);
  }

  @Action
  async getVipExcelDetail(params: any) {
    return api.getVipExcelDetail(params);
  }

  @Action
  async saveVipExcel(params: any) {
    return api.saveVipExcel(params);
  }

  @Action
  async importVipExcel(params: any) {
    return api.importVipExcel(params)
  }

  @Action
  async categorylist(params: any) {
    return api.categorylist(params);
  }

  @Action
  async addcategory(params: any) {
    return api.addcategory(params);
  }

  @Action
  async editcategory(params: any) {
    return api.editcategory(params);
  }

  @Action
  async categorydetail(params: any) {
    return api.categorydetail(params);
  }

  @Action
  async deletecategory(params: any) {
    return api.deletecategory(params);
  }

  @Action
  async phraselist(params: any) {
    return api.phraselist(params);
  }

  @Action
  async addphrase(params: any) {
    return api.addphrase(params);
  }

  @Action
  async editphrase(params: any) {
    return api.editphrase(params);
  }

  @Action
  async phrasedetail(params: any) {
    return api.phrasedetail(params);
  }

  @Action
  async deletephrase(params: any) {
    return api.deletephrase(params);
  }

  @Action
  async phraseselect(params: any) {
    return api.phraseselect(params);
  }

  @Action
  async chartsdata(params: any) {
    return api.chartsdata(params);
  }

  @Action
  async categoryselect(params: any) {
    return api.categoryselect(params);
  }
}
